import styled from '@emotion/styled';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f6f8;
`;

export const TabsHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #ddd;
  background-color: white;
  padding: 0 40px;
`;

export const TabButton = styled.button`
  padding: 16px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid
    ${(props) => (props.active ? '#4285f4' : 'transparent')};
  color: ${(props) => (props.active ? '#4285f4' : '#666')};
  font-size: 16px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: #4285f4;
  }

  &:focus {
    outline: none;
  }
`;

export const TabContent = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  flex: 1;
  padding: 40px;
  width: 100%;
  box-sizing: border-box;
`;
